import React from 'react';

const HeroV2 = ({ copy, buildHref }) => {
  if (!copy) return null;
  const href = typeof buildHref === 'function' ? buildHref('/v2/audit') : '/v2/audit';
  return (
    <section className="iv2-hero" data-testid="iv2-hero">
      <div className="iv2-container iv2-hero-inner">
        <p className="iv2-hero-eyebrow">{copy.eyebrow}</p>
        <h1 className="iv2-hero-title" data-testid="iv2-hero-title">
          {copy.title_lines.map((line, i) => (
            <span key={`line-${i}`} className="iv2-hero-title-line">{line}</span>
          ))}
        </h1>
        <p className="iv2-hero-lede" data-testid="iv2-hero-lede">{copy.lede}</p>
        <a href={href} className="iv2-btn iv2-btn-primary iv2-hero-cta" data-testid="iv2-hero-cta">{copy.primary_cta}</a>
        <div className="iv2-hero-badges" data-testid="iv2-hero-badges">
          {copy.badges.map((b, i) => (<span key={`b-${i}`}>{b}</span>))}
        </div>
      </div>
    </section>
  );
};
export default HeroV2;
